// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"fae89366","908":"4dfc97ca","925":"a1163858"}[chunkId] + ".chunk.js";
};